import angular from 'angular';

import './user-settings.styles.scss';

import UserSettingsController from './user-settings.controller';
import Routes from './user-settings.routes';

export default angular.module('autoboard.userSettings', [])
  .config(Routes)
  .controller('UserSettingsController', UserSettingsController)
  .name;
